import React from 'react';
import Modal from '../../../../../components/Modal';
import PropTypes from 'prop-types';
import ClassRoomModal from '../../../../../assets/images/ClassRoomModal.png';

const ConfirmationModal = ({
  isOpen,
  onClose,
  contentWidth,
  onSave,
  buttonPosition,
  content,
  cancelButton,
  confirmButton,
  showIcon,
  icon
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      contentWidth={contentWidth}
      detailHeight={'auto'}
      hideHeader={true}>
      <div className="confirmation-wrapper m-3 pt-3">
        <div className="confirmation-content p-3">
          <div className={`${showIcon ? 'confirmation-icon pb-3' : 'd-none'}`}>
            <img src={ClassRoomModal} className="img-fluid" />
          </div>
          <div>
            <p style={{color:"rgba(54, 55, 78, 1)", fontWeight:'bold'}} className="mb-0">{content}</p>
          </div>
          <div>
            <p className="mb-0">
              Warning: You are leaving the Classroom View and returning to the Castle. You will lose
              the text and patterns you marked.
            </p>
          </div>
        </div>
        <div className={`d-flex justify-content-${buttonPosition} gap-2`}>
          <button style={{width:"10%"}} className="btn btn-castleWhite" onClick={onClose} >
            No
          </button>
          <button style={{width:"10%"}} className="btn btn-castleRed" onClick={onSave} >
            Yes
          </button>
        </div>
      </div>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  contentWidth: PropTypes.string,
  onSave: PropTypes.func.isRequired,
  buttonPosition: PropTypes.string,
  content: PropTypes.string,
  cancelButton: PropTypes.string,
  confirmButton: PropTypes.string,
  showIcon: PropTypes.bool,
  icon: PropTypes.string
};

export default ConfirmationModal;
